class TraceDetailsModalController {
    constructor($timeout, $log, $uibTooltip, $uibModal, $q, moment, toastr, TraceDetailsServiceApi, UtpSummaryServiceApi, PaginatorService, DownloadXmlExService, TraceHubExService, TestTracesService, ngProgressFactory, SettingsExService, WaiverServiceApi, StoredItemsService, UserDetailsApi, $location, ViewMediaModalService, UtpTestExecutionServiceApi, GroupTesterSimServiceApi, ConvertService, ModalService, ManageTestSuiteServiceApi, ScriptInjectionService, TraceClassService) {
        // Used because $onChanges can fire before $onInit
        this.isInitialized = false;
        this.$onInit = () => {
            if (!this.isInitialized) {
                this.state = {};
                this.traceProgress = this.ngProgressFactory.createInstance();
                this.state = {
                    attachmentsRequest: {},
                    autoRefresh: false,
                    isNewDetails: false,
                    maxUploadMb: 0,
                    projectIterationId: 0,
                    selectedSim: {},
                    selectedSuite: {},
                    selectedTest: {},
                    prevTest: {},
                    nextTest: {},
                    currentTest: {},
                    lastTest: {},
                    firstTest: {},
                    selectedTester: {},
                    selectedTraceId: 0,
                    showSpinner: false,
                    modalClosing: false,
                    testInfo: {},
                    timedOut: false,
                    todaysTracesOnly: false,
                    traceSummaryRequest: {},
                    tracesLoaded: false,
                    testCaseLoaded: false,
                    waiverWithNotes: {},
                    xsButtons: false,
                    viewMode: false,
                    runMode: false,
                    fromTester: false,
                    data: {
                        Rows: {}
                    },
                    currentPage: 0,
                    itemsPerPage: 0,
                    totalItems: 0,
                    isNewTraces: false,
                    connectionId: '',
                    settingsLoaded: false,
                    enableReceipts: true,
                    enableReports: true,
                    enableTestInstructions: true,
                    enableWaiversAndNotes: true,
                    traceColumnWidth: 'col-md-7',
                    projectTestingView: false,
                    testMode: '',
                    enableSandbox: false,
                    testcaseVariables: [],
                    testVariableErrors: [],
                    testRunContext: undefined,
                    hasInitiatedTest: false
                };
                this.data = {
                    userTests: {},
                    Rows: {},
                    fullRows: {},
                    todaysRows: {},
                    traceAttributes: {}
                };
                this.context = {
                    selectedNodes: [],
                    traceClass: this.TraceClassService.traceClass,
                    subTraceClass: this.TraceClassService.subTraceClass
                };
                this.attachments = {};
                this.notes = {};
                this.receipts = {};
                this.logs = {};
                this.attachmentRequest = {};
                this.resolve = {};
                this.testvariablesModel = {};
                this.testvariablesFields = [];
                this.testDetails = {
                    Tester: { Id: 0, Name: '' },
                    Sim: { Id: 0, Name: '' },
                    Suite: { Id: 0, Name: '' },
                    Test: { Id: 0, Name: '', TruncatedNameMedium: '', TruncatedNameNarrow: '', TruncatedNameWide: '' },
                    Project: { Id: 0, Name: '' },
                    Iteration: { Id: 0, Name: '' },
                    Brand: { Id: 0, Name: '' },
                    ProjectIterationId: 0,
                    SimTestMode: '',
                    TestcaseVariables: {}
                };
                this.userTestCaseScript = {
                    Id: 0,
                    UserId: 0,
                    SimulatorId: 0,
                    TestCaseId: 0,
                    ScriptContent: undefined
                };
                this.SettingsExService.getSettings().then((response) => {
                    const appSettings = response.data;
                    // SIGNAL R SECTION
                    this.TraceHubExService.connectWithSpecificTransport('TraceDetailsModalController', appSettings.SignalRTransport);
                    this.TraceHubExService.on('TraceDetailsModalController', 'onInit', (connId) => {
                        this.state.connectionId = connId;
                    });
                    this.TraceHubExService.on('TraceDetailsModalController', 'onNewTraces', (dto) => {
                        // We want traces pushed to our connectionId which we got from onInit
                        if (dto.ConnectionId !== this.state.connectionId) {
                            return;
                        }
                        if (!dto.TreeViewNodes)
                            return;
                        // Make sure all the traces are actually relevant for this trace details modal eg. we may be user A but user B has generated a trace for this exact
                        // test case/sim combo. We'll still get a trace here but it's not for us
                        const nodes = this.TestTracesService.filterRows(dto.TreeViewNodes, this.state.traceSummaryRequest);
                        if (nodes.length === 0)
                            return;
                        // Check if the new traces indicate a running test has completed
                        this.setIfAnyRunningTestCase(true).then(() => {
                            const testPageNodes = [];
                            const blockingInstructionNodes = [];
                            const nonBlockingInstructionNodes = [];
                            const standardNodes = [];
                            for (let node of nodes) {
                                switch (node.MessageType) {
                                    case 'TestPage':
                                        testPageNodes.push(node);
                                        break;
                                    case 'Instruction-blocking':
                                        blockingInstructionNodes.push(node);
                                        break;
                                    case 'Instruction-non-blocking':
                                        nonBlockingInstructionNodes.push(node);
                                        break;
                                    default:
                                        standardNodes.push(node);
                                        break;
                                }
                            }
                            if (testPageNodes.length > 0) {
                                // open the model dialog to request user input, if the current client actually requested a test to be run.
                                if (this.state.hasInitiatedTest) {
                                    this.openTestPagesModal(testPageNodes[0].Id);
                                }
                            }
                            if (blockingInstructionNodes.length > 0) {
                                // open the model dialog to request user input, if the current client actually requested a test to be run.
                                if (this.state.hasInitiatedTest) {
                                    this.openTestExecutionInstructionModal(blockingInstructionNodes[0]);
                                }
                            }
                            if (nonBlockingInstructionNodes.length > 0) {
                                this.toastr.info(nonBlockingInstructionNodes[0].Rows[0].fullLabel);
                            }
                            if (standardNodes.length === 0) {
                                return;
                            }
                            // Adjust the timestamps to the support/tester/support-ots timezone shown in the UI
                            let timeAdjustedNodes = this.TestTracesService.adjustToLocalTime(standardNodes, this.userDetails.TimezoneOffset);
                            if (this.state.autoRefresh) {
                                // Combine the new and the existing and put them in vm.state.data.Rows
                                // Test for todays traces or complete rows dataset
                                // Add the new rows to the start of the merged array so they appear at the top
                                let combinedTraces = this.state.todaysTracesOnly && this.data.todaysRows !== undefined
                                    ? _.union(timeAdjustedNodes, this.data.todaysRows)
                                    : _.union(timeAdjustedNodes, this.state.data.Rows);
                                // This is where the rows are stashed
                                this.state.data.Rows = combinedTraces;
                                // Update the today collection
                                this.data.todaysRows = this.data.todaysRows !== undefined
                                    ? _.union(timeAdjustedNodes, this.data.todaysRows)
                                    : timeAdjustedNodes;
                                // keep the full list (all) updated so we can toggle today/all
                                this.data.fullRows = _.union(timeAdjustedNodes, this.data.fullRows);
                                // pageChanged will show the last page if currentPage is undefined
                                this.state.currentPage = null;
                                this.pageChanged();
                            }
                            else {
                                // Otherwise stash the new nodes in the details cache and indicate that there is new stuff
                                this.TestTracesService.addToDetailsCache(timeAdjustedNodes);
                            }
                            this.state.isNewDetails = this.TestTracesService.isNewDetails;
                        });
                    });
                    this.TraceHubExService.on('TraceDetailsModalController', 'onTestNote', () => {
                        this.getWaiverStatus(this.selectedItems);
                    });
                    this.TraceHubExService.on('TraceDetailsModalController', 'onNewAttachments', (dto) => {
                        // Only accept traces for our own connection ID
                        if (dto.ConnectionId !== this.state.connectionId) {
                            return;
                        }
                        // We don't need to make a timestamp adjustment as we display relative time
                        // Get the attachments for this Test
                        let attachments = _.filter(dto.Attachments, (att) => {
                            return (att.UserId === this.state.selectedTester.Id &&
                                att.ProjectIterationId === this.state.projectIterationId &&
                                att.SimId === this.state.selectedSim.Id &&
                                att.SuiteId === this.state.selectedSuite.Id &&
                                att.TestId === this.state.selectedTest.Id);
                        });
                        // If we filtered down to nothing then just return
                        if (attachments.length === 0) {
                            return;
                        }
                        // Ignore what server is pushing, just pull on ur own based on client accessibility
                        let traceAttachmentRequest = {
                            UserId: this.selectedItems.selectedTester.Id,
                            ProjectIterationId: this.selectedItems.projectIterationId,
                            SimId: this.selectedItems.selectedSim.Id,
                            SuiteId: this.selectedItems.selectedSuite.Id,
                            TestId: this.state.selectedTest.Id,
                            WithFileContents: false,
                            TraceId: -1,
                            TraceUid: '',
                            CreatedBy: null
                        };
                        this.TraceDetailsServiceApi.getAttachmentsDto(traceAttachmentRequest).then((response) => {
                            this.attachments = response.data;
                            let dto = response.data;
                            this.notes = dto.Notes;
                            this.receipts = dto.Receipts;
                            this.logs = dto.Logs;
                            this.attachmentRequest = traceAttachmentRequest;
                        });
                    });
                });
                // END SIGNAL R SECTION
                this.isInitialized = true;
            }
        };
        this.$onDestroy = () => {
            this.TraceHubExService.stop('TraceDetailsModalController');
        };
        this.sortByReverseTimestamp = (lst) => {
            let ascending = _.sortBy(lst, (x) => {
                return x.Timestamp;
            });
            return ascending.reverse();
        };
        this.$onChanges = (changes) => {
            // Make sure we're initialized
            this.$onInit();
            if (!changes.resolve) {
                return;
            }
            this.resolve = angular.copy(changes.resolve.currentValue);
            let params = this.resolve.params;
            this.selectedItems = params.selectedItems;
            this.user = params.user;
            this.mode = params.mode;
            this.overTheShoulder = params.overTheShoulder;
            this.state.projectTestingView = params.projectTestingView;
            this.state.testMode = '';
            // Will decide if the sandbox is to be enabled when the test details are fetched
            this.state.enableSandbox = false;
            if (!this.selectedItems) {
                this.toastr.warning('You must supply a valid selectedItems parameter');
            }
            if (!this.user) {
                // Additional chance at getting user
                this.UserDetailsApi.get().then((response) => {
                    this.user = response.data;
                });
                if (!this.user) {
                    this.toastr.warning('You must supply a valid user parameter');
                }
            }
            if (!this.mode) {
                this.toastr.warning('You must supply a valid mode parameter');
            }
            this.setState();
            this.init();
        };
        this.setState = () => {
            this.state.selectedTester = this.selectedItems.selectedTester;
            this.state.selectedTester = this.selectedItems.selectedTester;
            this.state.selectedSim = this.selectedItems.selectedSim;
            this.state.selectedSuite = this.selectedItems.selectedSuite;
            this.state.selectedTest = this.selectedItems.selectedTest,
                // if we dont have a projectIterationId being passed in then set to 0
                this.state.projectIterationId = (this.selectedItems.projectIterationId === null || this.selectedItems.projectIterationId === undefined) ? 0 : this.selectedItems.projectIterationId;
            this.state.autoRefresh = false;
            this.state.isNewDetails = false;
            this.state.showSpinner = false;
            this.state.timedOut = false;
            this.state.tracesLoaded = false;
            this.state.testCaseLoaded = false;
            this.state.todaysTracesOnly = this.mode.run || false,
                // We also need the TestCaseInformation column
                this.state.testInfo = this.selectedItems.selectedTest,
                this.state.selectedTraceId = 0;
            // ItemsPerPage is set in the paginator service
            this.state.xsButtons = true;
            this.state.maxUploadMb = 0;
            this.state.waiverWithNotes.HasWaiver = false;
            // Required for next/prevTest
            this.showWaiverForm = false;
            // Show the Todays Only, TraceXML, Refresh, and ViewXML buttons initially as we are looking at Traces
            // vm.showTraceButtons = mode.run || false;
            this.showTraceButtons = false;
            this.userDetails = this.user;
            // UI toggles
            this.showInstructions = this.state.runMode;
            this.showReceipts = false;
            this.showLogs = false;
            this.state.enableReceipts = true;
            this.state.enableReports = true;
            this.state.enableTestInstructions = true;
            this.state.enableWaiversAndNotes = true;
        };
        this.init = () => {
            this.SettingsExService.getCachedSettings().then((settings) => {
                this.state.maxUploadMb = settings.MaxUploadMb;
                this.state.enableReceipts = settings.EnableReceipts;
                this.state.enableReports = settings.EnableReports;
                this.state.enableWaiversAndNotes = settings.EnableWaiversAndNotes;
                this.state.enableTestInstructions = settings.EnableTestInstructions;
                this.showTraceButtons = true;
                this.state.settingsLoaded = true;
                if (this.state.selectedTest.Id === 0 || this.state.selectedSuite.Id === 0) {
                    this.state.enableReceipts = false;
                    this.state.enableReports = false;
                    this.state.enableWaiversAndNotes = false;
                }
                if (this.state.enableReceipts || this.state.enableReports || this.state.enableWaiversAndNotes) {
                    this.state.traceColumnWidth = 'col-md-7';
                }
                else {
                    this.state.traceColumnWidth = 'col-md-12';
                }
                if (this.state.enableReceipts || this.state.enableReports || this.state.enableWaiversAndNotes) {
                    this.getAttachmentsDto(this.state.attachmentsRequest);
                }
                if (this.state.enableWaiversAndNotes) {
                    this.getWaiverStatus(this.selectedItems);
                }
            });
            this.state.traceSummaryRequest = {
                UserId: this.selectedItems.selectedTester.Id,
                ProjectIterationId: this.selectedItems.projectIterationId,
                SimId: this.selectedItems.selectedSim.Id,
                TestSuiteId: this.selectedItems.selectedSuite.Id,
                TestId: this.selectedItems.selectedTest.Id,
                Take: 200,
                Previous24Hours: false,
                UnknownUser: false,
                AddChildren: false,
                ConnectedUser: this.user,
                OverTheShoulder: this.overTheShoulder
            };
            // Take the over the shoulder setting from the params passed in.
            this.state.traceSummaryRequest.OverTheShoulder = this.overTheShoulder;
            this.userLastPage();
            this.state.attachmentsRequest = {
                UserId: this.selectedItems.selectedTester.Id,
                ProjectIterationId: this.selectedItems.projectIterationId,
                SimId: this.selectedItems.selectedSim.Id,
                SuiteId: this.selectedItems.selectedSuite.Id,
                TestId: this.selectedItems.selectedTest.Id,
                WithFileContents: false
            };
            this.getTestInfo(this.selectedItems.selectedTest.Id);
            this.getTestCases();
            this.setIfAnyRunningTestCase(); /* Retrieve if any test case running state for this user and sim */
            this.ManageTestSuiteServiceApi.isTestSuiteEnabledForScripting(this.selectedItems.selectedSuite.Id).then((response) => {
                this.isScriptEnabled = response.data;
            });
        };
        this.setIfAnyRunningTestCase = (checkIsTestCaseRunningAfterNewTrace = false) => {
            let testDetailsRequest = {
                TesterId: this.selectedItems.selectedTester.Id,
                ProjectIterationId: this.selectedItems.projectIterationId,
                SimId: this.selectedItems.selectedSim.Id,
                SuiteId: this.selectedItems.selectedSuite.Id,
                TestId: this.selectedItems.selectedTest.Id
            };
            this.TraceDetailsServiceApi.testDetails(testDetailsRequest).then((response) => {
                let testDetailsResponse = response.data;
                this.testDetails = testDetailsResponse;
                this.state.testMode = this.testDetails.SimTestMode;
                this.state.testVariableErrors = testDetailsResponse.TestVariableErrors;
                this.state.enableSandbox = this.state.testVariableErrors.length > 0;
                this.getUserTestCaseScript();
                if (testDetailsResponse.TestcaseVariables.length > 0 && this.state.testMode !== undefined && this.state.testMode === 'Sandbox') {
                    this.getTestVariableHistory(this.selectedItems.selectedTest.Id, this.selectedItems.selectedTester.Id);
                }
            });
            return this.UtpTestExecutionServiceApi.isTestCaseCurrentlyRunning(this.state.selectedTester.Id, this.state.selectedSim.Id, this.state.selectedSuite.Id, this.state.selectedTest.Id)
                .then((response) => {
                let checkDto = response.data;
                const canRunTest = !checkDto.IsTestCaseRunning && !checkDto.IsTestCaseSuspended;
                if (checkDto != null) {
                    this.state.testRunContext = {
                        runningTest: checkDto.RunningTestCase,
                        runByIDPUser: (this.user.IsGroupTester && this.user.SingleSignOnDetails) ? this.userDetails.SingleSignOnDetails.IdPID : '',
                        buttonText: canRunTest ? 'Run Test' : 'Cancel Test',
                        showRunButton: !checkDto.IsTestCaseRunning,
                        isTestSuspended: checkDto.IsTestCaseSuspended,
                        isTestRestartable: checkDto.IsTestCaseRestartable
                    };
                    // We only care about checking this if we are getting a call to this method after a trace has come in via SignalR
                    if (canRunTest && checkIsTestCaseRunningAfterNewTrace) {
                        this.state.hasInitiatedTest = false;
                    }
                }
            });
        };
        this.setupTestcaseVariableValues = (testcaseVarHistoryArray) => {
            // clear any test case variables held in the state
            this.state.testcaseVariables = [];
            let idx = 0;
            for (idx = 0; idx < testcaseVarHistoryArray.length; idx++) {
                const tcVarHistoryDto = testcaseVarHistoryArray[idx];
                let testcaseVar = {
                    name: tcVarHistoryDto.TestcaseVariable.Name,
                    displayname: tcVarHistoryDto.TestcaseVariable.DisplayName,
                    id: tcVarHistoryDto.TestcaseVariable.Id,
                    variableValue: '',
                    defaultValue: tcVarHistoryDto.TestcaseVariable.DefaultValue,
                    possibleValues: tcVarHistoryDto.TestcaseVariable.PossibleValues ?
                        tcVarHistoryDto.TestcaseVariable.PossibleValues.split(',') :
                        [],
                    type: tcVarHistoryDto.TestcaseVariable.Type
                };
                // Find if the variable is already in the list
                let existingIdx = -1;
                if (this.state.testcaseVariables.length > 0) {
                    let idx2 = 0;
                    for (idx2 = 0; idx2 < this.state.testcaseVariables.length; idx2++) {
                        if (this.state.testcaseVariables[idx2].id === testcaseVar.id) {
                            existingIdx = idx2;
                            break;
                        }
                    }
                }
                if (existingIdx === -1) {
                    // Variable not already in list, so add new one
                    let newIdx = this.state.testcaseVariables.push(testcaseVar);
                }
                else {
                    // Variable is already in list at existingIdx, so update it
                    this.state.testcaseVariables[existingIdx].name = testcaseVar.name;
                    this.state.testcaseVariables[existingIdx].displayname = testcaseVar.displayname;
                    this.state.testcaseVariables[existingIdx].variableValue = '';
                }
            }
        };
        this.getTestVariableHistory = (testcaseId, testerId) => {
            this.TraceDetailsServiceApi.getTestVariableHistory(testcaseId, testerId).then((response) => {
                let testcaseVarHistoryArray = response.data;
                // only enable the Sandbox tab when we know we have something to show.
                this.state.enableSandbox =
                    this.state.testMode !== undefined &&
                        this.state.testMode === 'Sandbox' &&
                        (testcaseVarHistoryArray.length > 0 || this.state.testVariableErrors.length > 0);
                if (this.state.enableSandbox) {
                    this.setupTestcaseVariableValues(testcaseVarHistoryArray);
                    if (testcaseVarHistoryArray.length > 0) {
                        let varIdx = 0;
                        for (varIdx = 0; varIdx < testcaseVarHistoryArray.length; varIdx++) {
                            this.setDefaultTestcaseVariableVale(testcaseVarHistoryArray[varIdx]);
                        }
                    }
                    this.buildFormlyFieldDefinition();
                }
            });
        };
        this.buildFormlyFieldDefinition = () => {
            this.buildFormlyModelDefinition();
            // Clear out existing model definition
            this.testvariablesFields = [];
            let idx = 0;
            for (idx = 0; idx < this.state.testcaseVariables.length; idx++) {
                // Add formly definition of variable for input
                let tcVar = this.state.testcaseVariables[idx];
                const isSelectType = tcVar.type.toLowerCase() === 'select';
                let testVarField = {
                    className: 'row',
                    fieldGroup: [{
                            key: tcVar.id.toString(),
                            type: isSelectType ? 'select' : 'input',
                            className: 'col-xs-12',
                            templateOptions: {
                                notNull: true,
                                label: tcVar.displayname + (tcVar.defaultValue ? ' (Default: ' + tcVar.defaultValue + ')' : ''),
                                placeholder: tcVar.defaultValue,
                                options: (isSelectType && tcVar.possibleValues && tcVar.possibleValues.length > 0)
                                    ? tcVar.possibleValues.sort()
                                        .map(i => ({ name: i, value: i, selected: i === tcVar.defaultValue }))
                                    : undefined
                            }
                        }]
                };
                this.testvariablesFields.push(testVarField);
            }
        };
        this.buildFormlyModelDefinition = () => {
            // Build json representing the current values for the variable
            // Opening formatting
            let formlyModelJson = '{\r\n';
            // formatting per variable
            let idx = 0;
            for (idx = 0; idx < this.state.testcaseVariables.length; idx++) {
                let tcVar = this.state.testcaseVariables[idx];
                formlyModelJson += '"' + tcVar.id.toString() + '"';
                formlyModelJson += ':"' + tcVar.variableValue + '"';
                if (idx < this.state.testcaseVariables.length - 1) {
                    formlyModelJson += ',';
                }
                formlyModelJson += '\r\n';
            }
            // closing formatting
            formlyModelJson += '}';
            // Convert to format readable by formly
            this.testvariablesModel = angular.fromJson(formlyModelJson) || {};
        };
        this.testVariableUpdate = (updatedValues) => {
            let jsonStr = angular.toJson(updatedValues);
            let req = {
                TestCaseId: this.state.selectedTest.Id,
                JsonVaraibleValues: jsonStr
            };
            this.TraceDetailsServiceApi.updateTestVariableHistory(req, this.selectedItems.selectedTester.Id).then((response) => {
                let result = response.data;
                if (result.success === true) {
                    this.toastr.info('Testcase variable values updated successfully');
                }
                else {
                    let idx = 0;
                    for (idx = 0; idx < result.errors.length; idx++) {
                        this.toastr.error(result.errors[idx]);
                    }
                }
            });
        };
        this.setDefaultTestcaseVariableVale = (tcVar) => {
            let existingIdx = -1;
            if (this.state.testcaseVariables.length > 0) {
                let idx2 = 0;
                for (idx2 = 0; idx2 < this.state.testcaseVariables.length; idx2++) {
                    if (this.state.testcaseVariables[idx2].id === tcVar.TestcaseVariable.Id) {
                        existingIdx = idx2;
                        break;
                    }
                }
            }
            if (existingIdx >= 0 && existingIdx < this.state.testcaseVariables.length) {
                if (tcVar.TestcaseVariableValues.length > 0) {
                    this.state.testcaseVariables[existingIdx].variableValue = tcVar.TestcaseVariableValues[0];
                }
                else {
                    this.state.testcaseVariables[existingIdx].variableValue = tcVar.TestcaseVariable.DefaultValue;
                }
            }
            else if (existingIdx === -1) {
                // The definition wasn't already in the list, so add it
                let varVal = {
                    id: tcVar.TestcaseVariable.Id,
                    name: tcVar.TestcaseVariable.Name,
                    displayname: tcVar.TestcaseVariable.DisplayName,
                    variableValue: '',
                    type: tcVar.TestcaseVariable.Type,
                    possibleValues: tcVar.TestcaseVariable.PossibleValues.split(','),
                    defaultValue: tcVar.TestcaseVariable.DefaultValue
                };
                if (tcVar.TestcaseVariableValues.length > 0) {
                    varVal.variableValue = tcVar.TestcaseVariableValues[0];
                }
                this.state.testcaseVariables.push(varVal);
            }
        };
        this.getWaiverStatus = (selectedItems) => {
            let waiverRequest = this.createWaiverRequest(selectedItems);
            this.WaiverServiceApi.waiverWithNotes(waiverRequest).then((response) => {
                let waiverWithNotes = response.data;
                this.configureWaiverButton(this.user, waiverWithNotes);
            });
        };
        this.configureWaiverButton = (user, waiverWithNotes) => {
            // We need this for the function call
            this.waiverWithNotes = waiverWithNotes;
            // Show the waiver status
            this.waiverStatus = this.waiverWithNotes.HasWaiver
                ? this.waiverWithNotes.WaiverStatus.toString()
                : 'Request';
        };
        this.createWaiverRequest = (selectedItems) => {
            let waiverRequest = {
                TesterId: selectedItems.selectedTester.Id,
                ProjectIterationId: selectedItems.projectIterationId,
                SimId: selectedItems.selectedSim.Id,
                SuiteId: selectedItems.selectedSuite.Id,
                TestId: selectedItems.selectedTest.Id
            };
            return waiverRequest;
        };
        this.openWaiverModal = (selectedItems, waiverWithNotes) => {
            let modalInstance = this.uibModal.open({
                animation: true,
                backdrop: 'static',
                component: 'waiverModal',
                resolve: {
                    selectedItems: () => {
                        return selectedItems;
                    },
                    waiverWithNotes: () => {
                        return waiverWithNotes;
                    }
                }
            });
            modalInstance.result.then(
            // close callback
            (waiverWithNotes) => {
                this.getWaiverStatus(this.selectedItems);
            }, 
            // dismiss callback
            (waiverWithNotes) => {
                // Nothing to do on dismiss
                // console.log('Waiver dismissed');
            });
        };
        this.openTestExecutionInstructionModal = (instructionTrace) => {
            let modalInstance = this.uibModal.open({
                animation: true,
                backdrop: 'static',
                component: 'testInstructionUserInput',
                resolve: {
                    instructionTraceTreeVM: () => {
                        return instructionTrace;
                    },
                }
            });
            modalInstance.result.then(
            // close callback
            (params) => {
                let req = {
                    UserId: this.state.selectedTester.Id,
                    SimId: this.state.selectedSim.Id,
                    ParamValues: this.ConvertService.ToDictionary(params)
                };
                this.provideTestInstructionValues(req);
            }, 
            // dismiss callback
            () => {
                let cancelRequest = {
                    UserId: this.state.selectedTester.Id,
                    SimId: this.state.selectedSim.Id,
                    TestId: this.state.selectedTest.Id,
                    SuiteId: this.state.selectedSuite.Id
                };
                this.cancelTestWithoutConfirmation(cancelRequest);
            });
        };
        this.openTestPagesModal = (testPageTraceId) => {
            let modalInstance = this.uibModal.open({
                animation: true,
                backdrop: 'static',
                component: 'testPagesModal',
                resolve: {
                    testPageTraceId: () => {
                        return testPageTraceId;
                    },
                }
            });
        };
        this.provideTestInstructionValues = (req) => {
            this.TraceDetailsServiceApi.provideTestExecutionInstructionValues(req);
        };
        this.getTestInfo = (testId) => {
            this.TraceDetailsServiceApi.getTestInfo(testId).then((response) => {
                this.state.selectedTest = response.data;
                this.state.currentTest = this.state.selectedTest;
            });
        };
        this.pageChanged = () => {
            this.data.Rows = [];
            let pagedItems = this.PaginatorService.pagedItems(this.state.data.Rows, this.state.currentPage);
            this.data.Rows = pagedItems.data;
            this.state.currentPage = pagedItems.page;
            this.state.itemsPerPage = pagedItems.per_page;
            this.state.totalItems = pagedItems.total;
            this.state.autoRefresh = pagedItems.page === pagedItems.total_pages;
            // Nothing selected so set the selectedTraceId to zero
            this.state.selectedTraceId = 0;
        };
        // We need this to initialise the trace list
        this.userLastPage = () => {
            // TODO: Disable next/prev buttons while data is being retrieved
            this.state.tracesLoaded = false;
            let promise;
            // this.data.Rows = any[];
            promise = this.timeout(() => {
                this.state.showSpinner = true;
            }, 100);
            this.TraceDetailsServiceApi.lastPage(this.state.traceSummaryRequest).then((response) => {
                if (!response) {
                    this.timeout.cancel(promise);
                    this.state.timedOut = true;
                    return;
                }
                // Calculate the timestamp string for the top of the trace list.
                let lastPageResponse = response.data;
                // Put the full data rows into the fullrows item then filter the rows for todays only
                let rows = lastPageResponse.Rows;
                this.timeZone = lastPageResponse.Timezone;
                this.setTimestampText();
                this.data.fullRows = rows;
                this.data.todaysRows = _.filter(rows, (row) => {
                    return this.moment(row.MessageTimestamp).isAfter(this.moment().startOf('day'));
                });
                // If we want only todays traces then switch to that now.
                if (this.state.todaysTracesOnly) {
                    rows = this.data.todaysRows;
                }
                this.pageItems(rows);
                // We store our traces nodes in vm.state.data
                this.state.data = lastPageResponse;
                this.timeout.cancel(promise);
                this.state.showSpinner = false;
                // When we load the page we have autoRefresh off and we switch it on once we have traces
                this.state.autoRefresh = true;
                this.state.tracesLoaded = true;
            });
        };
        this.setTimestampText = () => {
            // If DataValidator then we do not need timestamp message
            let isDataValidatorSearch = this.location.absUrl().indexOf('DataValidator') !== -1;
            if (isDataValidatorSearch) {
                this.timestampText = '';
                return;
            }
            // Set the text for the timezone
            let yourLocalTime = [
                'Trace timestamps have been adjusted to your local time (',
                this.timeZone,
                ')'
            ].join('');
            let testersLocalTime = [
                'Trace timestamps have been adjusted to the testers local time (',
                this.timeZone,
                ')'
            ].join('');
            let isTester = this.userDetails.IsTester;
            // If User is here on their own trace summary view timestamp for them, if they are supporting then timestamp for the supported user
            if (!this.state.traceSummaryRequest.OverTheShoulder) {
                this.timestampText = yourLocalTime;
            }
            else {
                this.timestampText = testersLocalTime;
            }
        };
        this.pageItems = (rows) => {
            let pagedItems = this.PaginatorService.pagedItems(rows, 0);
            this.state.currentPage = pagedItems.page;
            this.state.itemsPerPage = pagedItems.per_page;
            this.state.totalItems = pagedItems.total;
            // We only display the trace nodes for the current page
            this.data.Rows = pagedItems.data;
        };
        this.toggleTodayOnly = () => {
            this.state.todaysTracesOnly = !this.state.todaysTracesOnly;
            let rows = this.data.fullRows;
            // If we want only todays traces then switch to that now.
            if (this.state.todaysTracesOnly) {
                rows = this.data.todaysRows;
            }
            this.pageItems(rows);
        };
        this.retryTraces = () => {
            this.state.timedOut = false;
            this.userLastPage();
        };
        this.toggleAutoRefresh = () => {
            this.state.autoRefresh = !this.state.autoRefresh;
            if (!this.state.autoRefresh) {
                return;
            }
            let nodes = this.TestTracesService.fetchFromDetailsCache();
            this.state.isNewTraces = false;
            // The existing nodes are stashed in vm.state.data
            // Test for todays traces or complete rows dataset
            // Add the new rows to the start of the merged array so they appear at the top
            let combinedTraces = this.state.todaysTracesOnly && this.data.todaysRows !== undefined
                ? _.union(nodes, this.data.todaysRows)
                : _.union(nodes, this.state.data.Rows);
            // This is where the rows are stashed
            this.state.data.Rows = combinedTraces;
            // Update the today collection
            this.data.todaysRows = this.data.todaysRows !== undefined
                ? _.union(nodes, this.data.todaysRows)
                : nodes;
            // keep the full list (all) updated so we can toggle today/all
            this.data.fullRows = _.union(nodes, this.data.fullRows);
            // pageChanged will show the last page if currentPage is undefined
            this.state.currentPage = null;
            this.pageChanged();
        };
        this.nodifyChildren = (node, context) => {
            this.timeout(() => {
                angular.forEach(node.$children, (node) => {
                    if (node.$hasChildren) {
                        let options = {};
                        let children = node.$model.children;
                        node.$children = context.nodifyArray(children, node, options);
                    }
                });
            });
        };
        // Treeview options
        this.options = {
            onExpand: ($event, node, context) => {
                // TODO: Confirm this
                let tvNode = node.$model;
                // onExpand => lazyLoad Message.Fields
                let traceId = node.$model.traceId;
                context.selectedNodes = [node];
                // Handle node.$model.MessageType differently
                if (node.$model.MessageType === 'raw-message') {
                    this.showRawMessage(traceId, node, context);
                    return;
                }
                else if (node.$model.MessageType !== 'CryptoSubItem') {
                    this.renderNodeChildren(node, context);
                }
            },
            onSelect: ($event, node, context) => {
                // We no longer care what the user passed in as they clicked something else!
                // this.context.selectedTraceId = null;
                context.selectedNodes = [node];
                let testId = node.$model.TestId;
                // Switch off auto refresh on trace select as per Trace Summary
                this.state.autoRefresh = false;
                if (!testId) {
                    return;
                }
                // TODO: This should not be neccessary as the test will not change
                if (testId !== this.state.selectedTest.Id) {
                    // Get the new test with added TestInformation field
                    this.TraceDetailsServiceApi.getTestInfo(testId).then((response) => {
                        this.state.selectedTest = response.data;
                    });
                }
                let traceId = node.$model.traceId;
                this.state.selectedTraceId = traceId;
                this.UtpSummaryServiceApi.getTraceXmlAttributes(traceId).then((response) => {
                    this.data.traceAttributes = response.data;
                });
            },
            onCollapse: ($event, node, context) => {
                context.selectedNodes = [node];
                this.context.selectedNodes = context;
            }
        };
        this.renderNodeChildren = (node, context) => {
            let loaded = node.$model.loaded;
            if (node.$model.traceId > 0 && !loaded) {
                this.TraceDetailsServiceApi.getTraceChildren(node.$model.traceId).then((response) => {
                    node.$model.children = response.data;
                    node.$children = context.nodifyArray(response.data);
                    this.nodifyChildren(node, context); // Do this to populate grandchildren
                    node.$model.loaded = true;
                });
            }
        };
        this.isVerdictFile = (filename) => {
            return filename.split('.').pop() === 'verdict';
        };
        this.getAttachmentsDto = (attachmentRequest) => {
            this.TraceDetailsServiceApi.getAttachmentsDto(attachmentRequest).then((response) => {
                // TODO: Deprecate the vm.attachments
                // TODO: Change to local time for am-time-ago directive
                this.attachments = response.data;
                // NOTE: Support the test-notes, test-attachments, test-waiver components
                let dto = response.data;
                this.notes = dto.Notes;
                this.receipts = dto.Receipts;
                this.logs = dto.Logs;
                // this.selectedItems = this.selectedItems;
                this.attachmentRequest = attachmentRequest;
            });
        };
        this.getFromNowString = (utcTime) => {
            let utc = this.moment.utc(utcTime);
            let local = this.moment(utc).local();
            return this.moment(local).fromNow();
        };
        this.downloadXml = (previous24Hours) => {
            //  vm.summaryDto.TraceSummaryRequest contains the query for the current traces
            let traceSummaryRequest = angular.copy(this.state.traceSummaryRequest);
            traceSummaryRequest.Previous24Hours = previous24Hours;
            this.DownloadXmlExService.downloadXml(traceSummaryRequest);
        };
        this.downloadZip = (previous24Hours) => {
            // vm.summaryDto.TraceSummaryRequest contains the query for the current traces
            let traceSummaryRequest = angular.copy(this.state.traceSummaryRequest);
            traceSummaryRequest.Previous24Hours = previous24Hours;
            this.DownloadXmlExService.downloadZip(traceSummaryRequest);
        };
        this.viewXmlContent = (traceId) => {
            this.UtpSummaryServiceApi.getTraceXmlContent(traceId, true).then((response) => {
                let xml = response.data;
                // Package up our xml as a media object
                // TODO: Allow a shorter model to
                let media = {
                    Content: xml,
                    ContentSubType: 'text',
                    TraceUid: traceId
                };
                this.ViewMediaModalService.open(media);
            });
        };
        this.selectInstructions = (isInstructions) => {
            this.showTraceButtons = !isInstructions;
        };
        this.selectSandboxData = (isSandboxData) => {
        };
        this.isToday = (dt) => {
            let today = this.moment();
            let diff = today.diff(dt, 'days');
            return diff === 0;
        };
        this.cancel = (closeDialog) => {
            this.state.modalClosing = closeDialog;
            this.scriptSaveCheck().then(() => {
                let cancelRequest = {
                    UserId: this.state.selectedTester.Id,
                    SimId: this.state.selectedSim.Id,
                    TestId: this.state.selectedTest.Id,
                    SuiteId: this.state.selectedSuite.Id
                };
                this.UtpTestExecutionServiceApi.isTestCaseCurrentlyRunning(this.state.selectedTester.Id, this.state.selectedSim.Id, this.state.selectedSuite.Id, this.state.selectedTest.Id)
                    .then((response) => {
                    let CancelDto = response.data;
                    if (CancelDto != null && CancelDto.IsTestCaseSuspended && closeDialog) {
                        // in that specific case, the user wants to close the modal dialog for a suspended test
                        // => we don't want to block him with the cancel action
                        this.closeModalDialog();
                    }
                    else if (CancelDto != null && (CancelDto.IsTestCaseRunning || CancelDto.IsTestCaseSuspended)) {
                        if (CancelDto.IsTestCaseCancelBySameUser) {
                            this.cancelTest(cancelRequest, closeDialog);
                        }
                    }
                    else {
                        // No test running, so we can close dialog immediately
                        if (closeDialog) {
                            this.closeModalDialog();
                        }
                    }
                });
            });
        };
        this.closeModalDialog = () => {
            // Test if from Tester page and if so call close and and send bool to refresh
            if (this.state.fromTester) {
                this.state.tracesLoaded = false;
                this.state.testCaseLoaded = false;
                this.close({ tracesLoaded: true });
            }
            else {
                this.dismiss({ tracesLoaded: false });
            }
            this.state.modalClosing = false;
        };
        this.doCancelTest = (cancelTestReq, closeOnCancel) => {
            this.TraceDetailsServiceApi.cancelTest(cancelTestReq).
                then((response) => {
                this.UtpTestExecutionServiceApi
                    .cancelSimulatorTesting(cancelTestReq.UserId, cancelTestReq.SimId).then((response) => {
                    this.toastr.info('Test Case Cancelled');
                    this.state.testRunContext = Object.assign(Object.assign({}, this.state.testRunContext), { buttonText: 'Run Test', runningTest: { Id: 0, Name: '' }, showRunButton: true, isTestRestartable: false });
                });
                if (closeOnCancel) {
                    this.closeModalDialog();
                }
            });
        };
        this.cancelTestWithoutConfirmation = (cancelTestReq) => {
            this.doCancelTest(cancelTestReq, false);
        };
        this.cancelTest = (cancelTestReq, closeOnCancel) => {
            this.state.modalClosing = false;
            let modalOptions = {
                backdrop: 'static',
                actionButtonText: 'Yes, Cancel Test',
                closeButtonText: 'No, do not Cancel Test',
                headerText: 'Cancel Test',
                bodyText: 'Testing is currently in progress. Are you sure you want to cancel test ?'
            };
            this.ModalService.showModal({}, modalOptions).then(() => {
                this.doCancelTest(cancelTestReq, closeOnCancel);
            });
        };
        this.showRawMessage = (traceId, node, context) => {
            this.TraceDetailsServiceApi.getRawMessage(traceId, true).then((response) => {
                let media = response.data;
                try {
                    // If the content is JSON then we'll defer to the server because it will format it all nicely for us
                    let obj = JSON.parse(media.Content);
                    if (obj && typeof obj === 'object') {
                        this.renderNodeChildren(node, context);
                        return;
                    }
                }
                catch (e) { }
                this.ViewMediaModalService.open(media);
                // Collapse node after delay
                this.timeout(() => {
                    node.collapsed = true;
                }, 300);
            });
        };
        // Get a list of the user tests in this suite so that we can next/prev them
        this.getTestCases = () => {
            this.state.testCaseLoaded = false;
            let userId = this.selectedItems.selectedTester.Id; // 0 if unknown
            let simId = this.selectedItems.selectedSim.Id; // 0 if unknown
            let suiteId = this.selectedItems.selectedSuite.Id; // 0 if unknown
            let userModelRequest = {
                UserId: userId,
                SimId: simId,
                SuiteId: suiteId,
                WithResults: false,
                RestoreFullState: false
            };
            this.TraceDetailsServiceApi.getUserModel(userModelRequest).then((response) => {
                let getUserModelResponse = response.data;
                // TODO: Maybe we can refine this a bit as we are getting a big dto
                this.data.userTests = getUserModelResponse.ActiveTestCases; // length = 0 if unknown
                // If we don't have any then we can't next/prev them
                if (this.data.userTests.length === 0) {
                    this.state.viewMode = false;
                    this.state.runMode = false;
                    return;
                }
                this.state.currentTest = this.state.selectedTest;
                this.state.firstTest = _.first(this.data.userTests);
                this.state.lastTest = _.last(this.data.userTests);
                let currentTest = this.state.currentTest;
                this.state.prevTest = this.prevTest(this.data.userTests, currentTest);
                this.state.nextTest = this.nextTest(this.data.userTests, currentTest);
                this.state.testCaseLoaded = true;
            });
        };
        this.nextTest = (tests, currentTest) => {
            if (currentTest.Id === this.state.lastTest.Id) {
                return null;
            }
            let nextIndex = _.findIndex(tests, { Id: currentTest.Id }) + 1;
            return tests[nextIndex];
        };
        this.prevTest = (tests, currentTest) => {
            if (currentTest.Id === this.state.firstTest.Id) {
                return null;
            }
            let prevIndex = _.findIndex(tests, { Id: currentTest.Id }) - 1;
            return tests[prevIndex];
        };
        this.viewTest = (test) => {
            this.scriptSaveCheck().then(() => {
                this.state.tracesLoaded = false;
                this.state.testCaseLoaded = false;
                // Save this and restore selected test back in tester-home
                this.StoredItemsService.storeTest(test);
                this.state.selectedTest = test;
                this.state.currentTest = null;
                this.state.enableSandbox = false;
                this.state.testRunContext = undefined;
                let testDetailsRequest = {
                    TesterId: this.selectedItems.selectedTester.Id,
                    ProjectIterationId: this.selectedItems.projectIterationId,
                    SimId: this.selectedItems.selectedSim.Id,
                    SuiteId: this.selectedItems.selectedSuite.Id,
                    TestId: test.Id
                };
                this.TraceDetailsServiceApi.testDetails(testDetailsRequest).then((response) => {
                    let testDetailsResponse = response.data;
                    this.testDetails = testDetailsResponse;
                    // TODO: Set up vm.state.
                    this.state.traceSummaryRequest.TestId = test.Id;
                    this.userLastPage();
                    let traceAttachmentRequest = {
                        UserId: this.selectedItems.selectedTester.Id,
                        ProjectIterationId: this.selectedItems.projectIterationId,
                        SimId: this.selectedItems.selectedSim.Id,
                        SuiteId: this.selectedItems.selectedSuite.Id,
                        TestId: test.Id, // This is the next/prev test
                        WithFileContents: false,
                        TraceId: -1,
                        TraceUid: '',
                        CreatedBy: null
                    };
                    // Get and render the attachments
                    this.state.attachmentsRequest = traceAttachmentRequest;
                    this.getTestInfo(test.Id);
                    this.getAttachmentsDto(traceAttachmentRequest);
                    this.getTestCases();
                    this.selectedItems.selectedTest = test;
                    this.getWaiverStatus(this.selectedItems);
                    this.setIfAnyRunningTestCase();
                });
            });
        };
        this.startRunning = (test) => {
            if (this.selectedItems.selectedTest.Id !== test.Id) {
                // When prev/next buttons are used we also need to update the displayed test case
                this.viewTest(test);
            }
            else {
                this.state.testRunContext = undefined;
            }
            this.selectedItems.selectedTest = test;
            // Save this and restore selected test back in tester-home
            this.StoredItemsService.storeTest(test);
            let request = {
                UserId: this.state.selectedTester.Id,
                SimId: this.state.selectedSim.Id,
                SuiteId: this.state.selectedSuite.Id,
                // This is the next/prev test
                TestId: test.Id
            };
            let promise = this.timeout(() => {
                this.traceProgress.start();
            }, 1);
            this.TraceDetailsServiceApi.runTest(request).then((response) => {
                this.traceProgress.complete();
                this.timeout.cancel(promise);
                let result = response.data;
                if (result.errors.length > 0) {
                    for (let error of result.errors) {
                        this.toastr.error(error);
                    }
                    // Test has failed to start for some reason. Go check if we did actually start it
                    this.setIfAnyRunningTestCase(false);
                }
                else {
                    this.state.testRunContext = Object.assign(Object.assign({}, this.state.testRunContext), { buttonText: 'Cancel Test', runningTest: test, showRunButton: false });
                }
            }, () => {
                // Test has failed to start for some reason. Go check if we did actually start it
                this.setIfAnyRunningTestCase(false);
            });
        };
        // TODO: Check if we need to do this for the ManagedTester user
        // If so we will need to change the run ttest request object
        this.runTest = (test) => {
            this.state.hasInitiatedTest = true;
            /* First check if session is SSO and simulator is not locked. If it is then simply return with message */
            if (this.user.IsGroupTester && this.user.SingleSignOnDetails) {
                let req = {
                    TesterId: this.state.selectedTester.Id,
                    SimId: this.state.selectedSim.Id
                };
                this.GroupTesterSimServiceApi.isSimulatorLocked(req).then((response) => {
                    let lockData = response.data;
                    if (lockData.IsLocked && _.isNil(lockData.LockingError)) {
                        let modalOptions = {
                            backdrop: 'static',
                            actionButtonText: 'OK',
                            closeButtonText: 'Close',
                            headerText: 'Simulator locked',
                            bodyText: lockData.LockingSSOUserDetails['IdPEmail'] + ' is currently testing with the simulator. The simulator must be started by your account to enable testing.',
                            okOnly: true
                        };
                        this.ModalService.showModal({}, modalOptions);
                        return;
                    }
                    else if (!_.isNil(lockData.LockingError)) {
                        this.toastr.error(lockData.LockingError);
                    }
                    else {
                        this.UtpTestExecutionServiceApi.isAnyTestCaseCurrentlyRunning(this.state.selectedTester.Id, this.state.selectedSim.Id)
                            .then((response) => {
                            let checkDto = response.data;
                            if (checkDto != null && checkDto.IsTestCaseRunning) {
                                let modalOptions = {
                                    backdrop: 'static',
                                    actionButtonText: 'OK',
                                    closeButtonText: 'Close',
                                    headerText: 'Testing in progress',
                                    bodyText: 'Test in progress, please wait until running test is complete and try again',
                                    okOnly: true
                                };
                                this.ModalService.showModal({}, modalOptions);
                            }
                            else {
                                this.state.testRunContext = Object.assign(Object.assign({}, this.state.testRunContext), { runByIDPUser: this.userDetails.SingleSignOnDetails.IdPID // This will identify who has started without server roundtrip
                                 });
                                this.startRunning(test);
                            }
                        });
                    }
                });
            }
            else {
                this.startRunning(test);
            }
        };
        this.saveScript = () => {
            let tempReq;
            tempReq = {
                Id: this.userTestCaseScript.Id > 0 ? this.userTestCaseScript.Id : -1,
                SimulatorId: this.state.selectedSim.Id,
                TestCaseId: this.state.selectedTest.Id,
                UserId: this.state.selectedTester.Id,
                ScriptContent: this.scriptTextArea
            };
            if (this.ScriptInjectionService.isInjectedScript(tempReq.ScriptContent)) {
                this.toastr.error('Script content contains illegal characters');
                return;
            }
            this.TraceDetailsServiceApi.saveUserTestCaseScript(tempReq).then((response) => {
                if (response.data > -1) {
                    this.toastr.info('Script saved successfully');
                    this.getUserTestCaseScript();
                }
                else {
                    this.toastr.error('Unable to save script');
                }
            });
        };
        this.getUserTestCaseScript = () => {
            this.TraceDetailsServiceApi.getUserTestCaseScript(this.selectedItems.selectedTester.Id, this.selectedItems.selectedSim.Id, this.selectedItems.selectedTest.Id).then((response) => {
                this.userTestCaseScript = response.data;
                this.scriptTextArea = response.data.ScriptContent;
            });
        };
        this.scriptSaveCheck = () => {
            let tempScriptReq = {
                Id: this.userTestCaseScript.Id,
                SimulatorId: this.userTestCaseScript.SimulatorId,
                TestCaseId: this.userTestCaseScript.TestCaseId,
                UserId: this.userTestCaseScript.UserId,
                ScriptContent: this.scriptTextArea
            };
            if (this.scriptTextArea !== this.userTestCaseScript.ScriptContent) {
                let modalOptions = {
                    backdrop: 'static',
                    actionButtonText: 'Save Changes',
                    closeButtonText: 'Discard Changes',
                    headerText: 'Unsaved Script Changes',
                    bodyText: 'There are unsaved script changes. Navigating away without saving will discard them'
                };
                return this.ModalService.showModal({}, modalOptions).then(() => {
                    this.saveScript();
                    return true;
                }, () => {
                    return false;
                });
            }
            else {
                return this.q.resolve(true);
            }
        };
        this.timeout = $timeout;
        this.uibModal = $uibModal;
        this.q = $q;
        this.moment = moment;
        this.toastr = toastr;
        this.TraceDetailsServiceApi = TraceDetailsServiceApi;
        this.UtpSummaryServiceApi = UtpSummaryServiceApi;
        this.PaginatorService = PaginatorService;
        this.DownloadXmlExService = DownloadXmlExService;
        this.TraceHubExService = TraceHubExService;
        this.TestTracesService = TestTracesService;
        this.ngProgressFactory = ngProgressFactory;
        this.SettingsExService = SettingsExService;
        this.WaiverServiceApi = WaiverServiceApi;
        this.StoredItemsService = StoredItemsService;
        this.UserDetailsApi = UserDetailsApi;
        this.location = $location;
        this.ViewMediaModalService = ViewMediaModalService;
        this.UtpTestExecutionServiceApi = UtpTestExecutionServiceApi;
        this.GroupTesterSimServiceApi = GroupTesterSimServiceApi;
        this.ConvertService = ConvertService;
        this.ModalService = ModalService;
        this.ManageTestSuiteServiceApi = ManageTestSuiteServiceApi;
        this.ScriptInjectionService = ScriptInjectionService;
        this.TraceClassService = TraceClassService;
    }
}
angular.module('app').component('traceDetailsModal', {
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    },
    controllerAs: 'vm',
    templateUrl: 'scripts/app/partials/TraceDetails/trace-details.tpl.html',
    controller: TraceDetailsModalController
});
